import { useRuntimeConfig } from "#app";

const REQUIRED_PUBLIC_CONFIG = ["API_URL", "USER_ORIGIN"] as const;

export const useConfig = () => {
  const runtimeConfig = useRuntimeConfig();

  for (const key of REQUIRED_PUBLIC_CONFIG) {
    if (!runtimeConfig.public[key]) {
      throw new Error(
        `Missing required public runtime config: ${key}. Set it in .env before using this app.`
      );
    }
  }

  const config = {
    API_URL: runtimeConfig.public.API_URL,
    USER_ORIGIN: runtimeConfig.public.USER_ORIGIN as string
  };
  return {
    config
  };
};
